import * as types from "./types";



export const setExpandedSystem = (data) => ({
    type: types.SET_EXPANDED_SYSTEM, 
    payload: data
  });

